import React, { useState, useMemo,useEffect } from "react";
import {Container  } from "reactstrap";
import { useQuery} from "react-query";
import '../utils/index.css';
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import empty from "../../../../assets/images/emptyMarchand.png";
import { getAllAdmin } from "../services/userAdminApi";
import CreateAdminModal from "../component/CreateAdminModal";
import CollaborateursUser from "../../parametre-commission/component/collaborateurUser";
const Utilisateurs = () => {
 const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
const { isLoading, isError, error, data: merchents } = useQuery("merchents", getAllAdmin);
const [sortOrder, setSortOrder] = useState("asc");
const [activeTab1, setActiveTab1] = useState("Collaborateurs");
const tabs = ["Collaborateurs", "Rôles"];
const handleTabChange = (tab) => {
  setActiveTab1(tab);
};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const filteredMerchents = useMemo(() => {
    if (!merchents || merchents.length === 0) return [];
    let result = [...merchents];
    if (filterValues) {
        if (filterValues.active!=="") {
          result = result.filter((t) => t.active === filterValues.active);
        } 
        if (filterValues.countrie) {
          result = result.filter((t) => t.country === filterValues.countrie);
        }
        if (filterValues.createdDate) {
            result = result.filter((t) => {
              const txDate = new Date(t.createdDate).toISOString().slice(0, 10);
              return txDate === filterValues.createdDate;
            });
          }
      }
        if (sortOrder === "asc") {
            result.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
          } else {
            result.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          }
      if (!searchTerm) return merchents 
        const lowerSearch = searchTerm.toLowerCase();
          result = result.filter(mer =>{
          return (
        mer.firstName?.toLowerCase().includes(lowerSearch) ||
        mer.lastName?.toLowerCase().includes(lowerSearch) ||
        mer.phoneNumber?.toLowerCase().includes(lowerSearch)
      );
  }); 
      return result;
  }, [merchents,searchTerm,filterValues,sortOrder]);

  const columns = useMemo(() => [
   {
  Header: "Prénom",
  accessor: "firstName",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName}</span>
      </div>
    );
  }
},
{ Header: "Nom", accessor: "lastName", filterable: false },
{
     Header: () => (
    <div style={{ textAlign: "end", width: "100%" }}>
    N° Téléphone
    </div>
  ),
  accessor: "phoneNumber",
      Cell: ({row}) => {
        const {phoneNumber} = row.original;
        return (
           <div style={{ display: "flex", justifyContent: "end" }}>
             {phoneNumber}
            </div>
        );
      },
      filterable: false,
    },
    {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
    Email
    </div>
  ),
  accessor: "email",
      Cell: ({row}) => {
        const { email} = row.original;
        return (
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
             {email}
            </div>
        );
      },
      filterable: false,
    },
  ], []);
const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const HeaderTable = () => (
  <div className="d-flex flex-column align-items-start gap-3 w-100">
    <div  className="d-flex flex-wrap align-items-center  gap-2 mb-3 w-100">
      <div className="col-6">
        <input
        type="text"
        placeholder="Rechercher un admin..."
       className="form-control search"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    </div>
      <button className="buttonNewColla btn btn-primary ms-auto " onClick={() => setIsModalOpen(true)}>Nouveau collaborateur</button>
      </div>
      </div>
      );
    return (
    <React.Fragment>
     <div className="page-content">
        <Container fluid >
      <div
      style={{
        marginTop: "-10px",
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
  <div
    style={{
      backgroundColor: "#FFFFFF",
      color: "#000",
      padding: "5px 5px",
      display: "flex",
      borderRadius: "100px",
      gap: "8px",
    }}
  >
    {tabs.map((tab1) => (
      <div
        key={tab1}
        onClick={() => handleTabChange(tab1)}
        className={`mb-2 ${activeTab1 === tab1 ? "active" : ""}`}
        style={{
          backgroundColor: activeTab1 === tab1 ? "#396AFC14" : "#F5F5F5",
          color: activeTab1 === tab1 ? "#396AFC" : "#141414",
          padding: "5px 20px",
          fontFamily: "Poppins",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 400,
          fontSize: "14px",
          borderRadius: "100px",
          cursor: "pointer",
        }}
      >
        {tab1}
      </div>
    ))}
  </div>
</div>
 {activeTab1 === "Collaborateurs" && (
  <CollaborateursUser
    columns={columns}
    data={filteredMerchents}
    HeaderTable={HeaderTable}
    isLoading={isLoading}
    isError={isError}
    empty={empty}
  />
)}
<CreateAdminModal
  visible={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  /> 
</Container>
      </div>
    </React.Fragment>
  );
};

export default Utilisateurs;
